<template>
  <form class="login-modal">
    <b-modal
      :visible="error"
      no-close-on-backdrop
      no-close-on-esc
      hide-header
      @hidden="close()"
    >
      <p>
        Your session has expired, and you have been logged out.
      </p>
      <div slot="modal-footer">
        <button class="btn btn-reverse" @click.prevent="logInAgain()">
          <i class="fa fa-sign-in mr-1"></i>
          Log In Again
        </button>
      </div>
    </b-modal>
  </form>
</template>

<script>
import $ from 'jquery'
import axios from 'axios'
import { refreshCsrfToken } from '@/api'

export default {
  components: {
    //
  },
  props: {
    //
  },
  data () {
    return {
      ping: true,
      error: false
    }
  },
  mounted () {
    // XXX: this isn't working
    //this.startWatchingSession()

    $(window).on('session-error', () => {
      clearInterval(this.ping)
      this.error = true
      refreshCsrfToken()
    })
  },
  methods: {
    close () {
      this.$emit('close')
    },
    resumeWatchingSession () {
      this.startWatchingSession()
    },
    startWatchingSession () {
      this.error = false
      clearInterval(this.ping)
      this.ping = setInterval(() => {
        axios.get('/ping')
          .then((response) => {
            refreshCsrfToken(response.data)
          })
          .catch((response) => {
            clearInterval(this.ping)
            this.error = true
            refreshCsrfToken()
          })
      }, 10000)
    },
    logInAgain () {
      window.location.reload()
    }
  }
}
</script>
